//state
export var adsetsState = {
    ad_sets: [],
    ad_sets_all:[],
    campaign_ad_sets:[],
    custom_events:[],
    status_ad_sets: ""
  };
  
  //getters
  export var adsetsGetters = {
    getAdsets: state => state.ad_sets,
    getCampaignAdsets: state => state.campaign_ad_sets,
    getCustomEvents: state => state.custom_events
  };
  
  //actions
  export var adsetsActions = {
    async getCustomEvents({ commit }) {
      commit("ad_sets_request");
      await this._vm.$http
        .get("/apache/rest_api/apache.adset.custom.event", {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
            fields:
              '["id","name"]'
          }
        })
        .then(res => {
          var custom_events = res.data;
          commit("custom_events_success", custom_events);
          return res;
        })
        .catch(err => {
          commit("ad_sets_error");
          return err;
        });
    },
    async getAdsets({ commit }) {
      commit("ad_sets_request");
      await this._vm.$http
        .get("/apache/rest_api/apache.adset", {
          headers: {
            //"X-Odoo-dbfilter": "apachev1",
            fields:
              '["id",'+
              '"name",'+
              '"adset_id",'+
              '"create_time",'+
              '"status",'+
              '"state",'+
              '"campaign_dates",'+
              '"will_be_splited",'+
              '"pacing_start_minute",'+
              '"pacing_end_minute",'+
              '"start_date",'+
              '"end_date",'+
              '("optimization_goal_id",["id","name"]),'+
              '("custom_event_id",["id","name"]),'+
              '("billing_event_id",["id","name"]),'+
              '("targeting_id",["id","name"]),'+
              '("campaign_id",["id","name"]),'+
              '"is_imported"]'
          }
        })
        .then(res => {
          var adSets = res.data;
          var campaign_ad_sets = []
       
          adSets.map(adset=>{
            var campaign = adset.campaign_id
            var find = campaign_ad_sets.find(element => element.id == campaign.id)
            if(!find){
              campaign_ad_sets.push(campaign)
            }
          })
          commit("ad_sets_success", adSets);
          commit("ad_sets_all_success", adSets);
          commit("campaign_ad_sets_success", campaign_ad_sets);
          return res;
        })
        .catch(err => {
          commit("ad_sets_error");
          return err;
        });
    },
    async newAdsets({ commit, state }, adSet) {
      commit("page_request");
      var {
        state_id,
        pacing_type,
        status,
        will_be_splited,
        campaign_id,
        billing_event_id,
        pacing_start_minute,
        pacing_end_minute,
        name,
        targeting_id,
        start_date,
        end_date,
        campaign_dates,
        custom_event_id,
        optimization_goal_id
      } = adSet;
      var formData = new FormData();
      if(campaign_dates){
        var new_adset = `{
          'state':'${state_id}',
          'pacing_type': '${pacing_type.value}',
          'status':'${status.value}',
          'campaign_dates':'${campaign_dates? 'True': 'False'}',
          'will_be_splited': ${(will_be_splited)?'True':'False'},
          'campaign_id':${campaign_id.id},
          'optimization_goal_id': ${optimization_goal_id.id},
          'billing_event_id':${billing_event_id.id},
          'pacing_start_minute': ${pacing_start_minute},
          'pacing_end_minute':${pacing_end_minute},
          'name': '${name}',
          'targeting_id': ${targeting_id.id},
          'custom_event_id': ${custom_event_id.id},
          'relational_fields': [('targeting_id', 'apache.adset.targeting'),
                              ('campaign_id', 'apache.campaign'),
                              ('optimization_goal_id', 'apache.adset.optimization.goal'),
                              ('billing_event_id', 'apache.adset.billing.event'),
                              ('custom_event_id', 'apache.adset.custom.event')
                            ],
          }`;
      }else{
        var new_adset = `{
          'state':'${state_id}',
          'pacing_type': '${pacing_type.value}',
          'status':'${status.value}',
          'start_date': '${start_date}',
          'end_date': '${end_date}',
          'campaign_dates':'${campaign_dates? 'True': 'False'}',
          'will_be_splited': ${(will_be_splited)?'True':'False'},
          'campaign_id':${campaign_id.id},
          'optimization_goal_id': ${optimization_goal_id.id},
          'billing_event_id':${billing_event_id.id},
          'pacing_start_minute': ${pacing_start_minute},
          'pacing_end_minute':${pacing_end_minute},
          'name': '${name}',
          'targeting_id': ${targeting_id.id},
          'custom_event_id': ${custom_event_id.id},
          'relational_fields': [('targeting_id', 'apache.adset.targeting'),
                              ('campaign_id', 'apache.campaign'),
                              ('optimization_goal_id', 'apache.adset.optimization.goal'),
                              ('billing_event_id', 'apache.adset.billing.event'),
                              ('custom_event_id', 'apache.adset.custom.event')
                            ],
          }`;
      }
      formData.append("data", new_adset);
      await this._vm.$http
        .post("/apache/rest_api/apache.adset", formData, {
          headers: {
            "X-Odoo-dbfilter": "apachev1",
          }
        })
        .then(res => {
          if (res.status == 201) {
            adSet.id = res.data.id;
            adSets.push(adSet);
            commit("ad_sets_success", adSets);
            return adSets;
          } else {
            commit("ad_sets_error");
          }
        })
        .catch(err => {
          commit("ad_sets_error");
          return err;
        });
    },
    async editAdsets({ commit, state }, adSet) {
      commit("page_request");
      var {
        id,
        state_id,
        pacing_type,
        status,
        will_be_splited,
        campaign_id,
        optimization_goal_id,
        billing_event_id,
        pacing_start_minute,
        pacing_end_minute,
        name,
        targeting_id,
        start_date,
        end_date,
        campaign_dates,
        custom_event_id
      } = adSet;
      var formData = new FormData();
      if(campaign_dates){
        var new_adset = `{
          'state':'${state_id}',
          'pacing_type': '${pacing_type.value}',
          'status':'${status.value}',
          'campaign_dates':'${campaign_dates? 'True': 'False'}',
          'will_be_splited': ${(will_be_splited)?'True':'False'},
          'campaign_id':${campaign_id.id},
          'optimization_goal_id': ${optimization_goal_id.id},
          'billing_event_id':${billing_event_id.id},
          'pacing_start_minute': ${pacing_start_minute},
          'pacing_end_minute':${pacing_end_minute},
          'name': '${name}',
          'targeting_id': ${targeting_id.id},
          'custom_event_id': ${custom_event_id.id},
          'relational_fields': [('targeting_id', 'apache.adset.targeting'),
                              ('campaign_id', 'apache.campaign'),
                              ('optimization_goal_id', 'apache.adset.optimization.goal'),
                              ('billing_event_id', 'apache.adset.billing.event'),
                              ('custom_event_id', 'apache.adset.custom.event')
                            ],
          }`;
      }else{
        var new_adset = `{
          'state':'${state_id}',
          'pacing_type': '${pacing_type.value}',
          'status':'${status.value}',
          'start_date': '${start_date}',
          'end_date': '${end_date}',
          'campaign_dates':'${campaign_dates? 'True': 'False'}',
          'will_be_splited': ${(will_be_splited)?'True':'False'},
          'campaign_id':${campaign_id.id},
          'optimization_goal_id': ${optimization_goal_id.id},
          'billing_event_id':${billing_event_id.id},
          'pacing_start_minute': ${pacing_start_minute},
          'pacing_end_minute':${pacing_end_minute},
          'name': '${name}',
          'targeting_id': ${targeting_id.id},
          'custom_event_id': ${custom_event_id.id},
          'relational_fields': [('targeting_id', 'apache.adset.targeting'),
                              ('campaign_id', 'apache.campaign'),
                              ('optimization_goal_id', 'apache.adset.optimization.goal'),
                              ('billing_event_id', 'apache.adset.billing.event'),
                              ('custom_event_id', 'apache.adset.custom.event')
                            ],
          }`;
      }
      
      formData.append("data", new_adset);
      await this._vm.$http
        .put("/apache/rest_api/apache.adset", formData, {
          headers: {
            "X-Odoo-dbfilter": "apachev1",
          },
          params: {
            ids: `[${id}]`
          }
        })
        .then(res => {
          if (res.status == 200) {
            //adsAccount.id = res.data.id;
            var adSets = state.ad_sets;
            var index;
            adsAccount.account_status = adsAccount.account_status.value
            for (var i = 0; i < adSets.length; i++) {
              if (adSets[i].id == id) {
                index = i;
                adSets[i] = adsAccount;
                break;
              }
            }
            adSets.splice(index, 1);
            adSets.splice(index, 0, adsAccount);
            commit("ad_sets_success", adSets);
            return adSets;
          } else {
            commit("ad_sets_error");
          }
        })
        .catch(err => {
          commit("ad_sets_error");
          return err;
        });
    },
    async deleteAdsets({ commit, state }, id) {
      commit("ad_sets_request");
      await this._vm.$http
      .delete(`/apache/rest_api/apache.adset/${id}`, { 
        headers: {
            //"X-Odoo-dbfilter": "apachev1"
          }
        })
        .then(res => {
          if (res.status == 210) {
            var adSets = state.ad_sets
            commit("ad_sets_success", adSets);
            return adSets;
          } else {
            commit("ad_sets_error");
          }
        })
        .catch(err => {
          commit("partner_error");
          return err;
        });
    },
    async deleteAdsetsUtility({ commit, state }, id) {
      commit("ad_sets_request");
      var index;
      var adSets = state.ad_sets;
      for (var i = 0; i < adSets.length; i++) {
        if (adSets[i].id == id) {
          index = i;
          break;
        }
      }
      commit("ad_set_delete_success", index);
      return adSets;
    },
    async getFiltroCompaign({ commit, state }, campaign_id) {
      commit("page_request");
      var ad_sets_all = state.ad_sets_all;
      var new_ad_sets = []
      if(campaign_id == "todos"){
        new_ad_sets = ad_sets_all
      }else{
        for(var i = 0 ; i< ad_sets_all.length;i++){
          var campaign = ad_sets_all[i].campaign_id
          if(campaign.id == campaign_id){
            new_ad_sets.push(ad_sets_all[i])
          }
        }
      }
      commit("ad_sets_all_success", ad_sets_all);
      commit("ad_sets_success", new_ad_sets);
     
    },
  };
  
  //mutations
  
  export var adsetsMutations = {
    ad_sets_request(state) {
      state.status_ad_sets = "loading";
    },
    ad_sets_success(state, payload) {
      state.status_ad_sets = "success";
      const new_adsets = payload;
      state.ad_sets.splice(0,state.ad_sets.length);
      state.ad_sets.push(...new_adsets)
    },
    custom_events_success(state,payload){
      state.status_ad_sets = "success";
      state.custom_events = payload
    },
    ad_set_delete_success(state,payload){
      state.status_ad_sets = "success";
      state.ad_sets.splice(payload,1)
    },
    ad_sets_all_success(state, payload) {
      state.status_ad_sets = "success";
      state.ad_sets_all = payload;
    },
    campaign_ad_sets_success(state, payload) {
      state.status_ad_sets = "success";
      state.campaign_ad_sets = payload;
    },
    ad_sets_error(state) {
      state.status_ad_sets = "error";
    }
  };
  
// const fetch = require("node-fetch");

//   // fetch("https://tatanka.apachedigital.io/apache/rest_api/apache.adset", {
//   fetch("https://martech-api.apachedigital.io/apache/rest_api/apache.adset", {
//   "headers": {
//     "accept": "application/json, text/plain, */*",
//     "accept-language": "es-ES,es;q=0.9",
//     "content-type": "multipart/form-data; boundary=----WebKitFormBoundaryPLFVKaSSUFcASBlR",
//     "sec-fetch-dest": "empty",
//     "sec-fetch-mode": "cors",
//     "sec-fetch-site": "cross-site",
//     "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE1OTIxNDg4NTIsImlhdCI6MTU4OTU1MzI1Miwic3ViIjp7ImlkIjo3LCJuYW1lIjoiQVBJIn19.gZibXkhQMynrZ3VRJIpOGqEapxrrRhKDkivdyPVYLKM",
//     // "token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJleHAiOjE1O…0In19.OXpZYfnP3v7cM1mSsO9AQZKNXyLB5gRSdE3rmIZeFy0",
//     // "x-odoo-dbfilter": "apachev1"
//     "x-odoo-dbfilter": "apachev1"
//   },
//   "referrer": "http://localhost:8081/",
//   "referrerPolicy": "no-referrer-when-downgrade",
//   "body": "------WebKitFormBoundaryPLFVKaSSUFcASBlR\r\nContent-Disposition: form-data; name=\"data\"\r\n\r\n{\n        'state':'draft',\n        'pacing_type': 'no_pacing',\n        'status':'ACTIVE',\n        'start_date': '',\n        'end_date': '',\n        'campaign_dates': True,\n        'will_be_splited': False,\n        'campaign_id':415,\n        'optimization_goal_id': 3,\n        'billing_event_id': 3,\n        'pacing_start_minute': 0,\n        'pacing_end_minute':0,\n        'name': 'test',\n        'targeting_id': 169,\n        'custom_event_id': 4,\n        'relational_fields': [('targeting_id', 'apache.adset.targeting'),\n                            ('campaign_id', 'apache.campaign'),\n                            ('optimization_goal_id', 'apache.adset.optimization.goal'),\n                            ('billing_event_id', 'apache.adset.billing.event'),\n                            ('custom_event_id', 'apache.adset.custom.event')\n                          ],\n        }\r\n------WebKitFormBoundaryPLFVKaSSUFcASBlR--\r\n",
//   "method": "POST",
//   "mode": "cors",
//   "credentials": "include"
// });